import CustomModal from '@/components/shared/CustomModal/CustomModal'

const AlertModal = ({
    showModal,
    showHideModal,
    title,
    message,
}) => {
    
    return (
        
        <CustomModal
            open={showModal}
            modalHandler={() => showHideModal(!showModal)}
            center
            modalClass="modal-width-98">
            
            <div className="modal-header">
                <h2 className="modal-title">
                    {title}
                </h2>
            </div>
            
            <div className="modal-body">
                {message}
            </div>
            
            <div className="modal-footer flex justify-end">
                
                <button
                    type="button"
                    className="mr-3 btn btn-primary btn-outline"
                    onClick={() => showHideModal(false)}>
                    OK
                </button>
            
            </div>
        
        </CustomModal>
        
    )
    
}

export default AlertModal
